import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { isNumber } from 'lodash';
import { LightboxModal } from './lightbox.modal';

@Injectable({
  providedIn: 'root',
})
export class LightboxService {
  constructor(private modalCtrl: ModalController) {}

  public async show(images: any[], index: number = 0, fullPageModal = false) {
    const isArrayWithImages = Array.isArray(images) && images.length > 0;
    const isIndexCorrect = isNumber(index) && index >= 0 && index < images.length;
    if (!isArrayWithImages || !isIndexCorrect) {
      return;
    }
    const nonNullImages = images.filter(image => Boolean(image));
    if (nonNullImages.length === 0) {
      return;
    }
    images = nonNullImages.map(image => {
      const { Image } = image;
      if (Image) {
        const { uri } = Image;
        return uri ? uri : Image;
      }
      return image;
    });
    const modal = await this.modalCtrl.create({
      component: LightboxModal,
      componentProps: {
        images: images,
        currentIndex: index,
      },
      cssClass: fullPageModal === true ? 'fullPageModal' : '',
    });
    await modal.present();
  }
}
